<template>
  <div id="user" v-if="hasLogin">
    <div class="l">
      <Left></Left>
    </div>
    <div class="c"><Router-view /></div>
  </div>
</template>

<script>
import Left from "./components/left.vue";
import { mapState } from "vuex";
export default {
  name: "index",
  components: {
    Left,
    // Center,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["hasLogin", "token"]),
  },
  created() {
    this.getUser();
  },
  methods: {
    async getUser() {
      let token = sessionStorage.getItem('token')
      let { content } = await this.$apis.loginServe.getUserInfo();
      let userObj = {
        token,
        hasLogin: true,
        userInfo: content,
      };
      this.$store.commit("loginInfo", userObj);
      let userHasData = await this.$apis.userServe.authStatus();
      sessionStorage.setItem("userHasData", JSON.stringify(userHasData));
      this.toUserPage(userHasData, content)
    },
    toUserPage(userHasData, userInfo) {
      if (userHasData) {
        const { hasData, status, type } = userHasData;
        // type 1期刊 2学者 4机构
        // status 0审核中 1审核通过 2审核不通过
        // hasData true提交过认证 false没有提交过认证
        if (userInfo.user.subType) {
          if (this.$route.name === 'userAuthentication' ||
            this.$route.name === 'userReview' ||
            this.$route.name === 'userScholarRz' ||
            this.$route.name === 'userPeriodicalRz' ||
            this.$route.name === 'user') {
            this.$router.replace("/user/mytickets");
          }
        } else if (hasData) {
          //提交过认证
          if (status == 1) {
            //审核通过后不能在进入认证页面或状态审核页面
            if (this.$route.name === 'userAuthentication' ||
              this.$route.name === 'userReview' ||
              this.$route.name === 'userScholarRz' ||
              this.$route.name === 'userPeriodicalRz' ||
              this.$route.name === 'user') {
              this.$router.replace("/user/mytickets");
            }
          } else {
            if (!this.$route.meta || !this.$route.meta.noAuthority) {
              this.$router.replace("/user/review");
            }
          }
        } else {
          //没有提交过认证,跳转到认证页面
          if (!this.$route.meta || !this.$route.meta.noAuthority) {
            this.$router.replace("/user/authentication");
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#user {
  display: flex;
  // width: 1200px;
  justify-content: center;

  .c {
    margin-left: 15px;
    margin-top: 30px;
    width: 1200px;
  }

  .l {
    margin-top: 30px;
    //margin-left: 60px;
    // margin-right: 57px;
  }
}
</style>
